'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CURRENT_USER_GET_DETAILS = exports.CURRENT_USER_GET_DETAILS = 'CURRENT_USER_GET_DETAILS';
var CURRENT_USER_GET_FAILURE = exports.CURRENT_USER_GET_FAILURE = 'CURRENT_USER_GET_FAILURE';
var CURRENT_USER_SET = exports.CURRENT_USER_SET = 'CURRENT_USER_SET';
var CURRENT_USER_SET_GUEST = exports.CURRENT_USER_SET_GUEST = 'CURRENT_USER_SET_GUEST';
// Image actions
var CURRENT_USER_IMAGE_SET = exports.CURRENT_USER_IMAGE_SET = 'CURRENT_USER_IMAGE_SET';
var CURRENT_USER_IMAGE_UPLOAD_COMPLETE = exports.CURRENT_USER_IMAGE_UPLOAD_COMPLETE = 'CURRENT_USER_IMAGE_UPLOAD_COMPLETE';
var CURRENT_USER_IMAGE_UPLOAD_ERROR = exports.CURRENT_USER_IMAGE_UPLOAD_ERROR = 'CURRENT_USER_IMAGE_UPLOAD_ERROR';


//////////////////
// WEBPACK FOOTER
// ./src/client/user/currentUserConstants.js
// module id = 144
// module chunks = 0